global.$ = global.jQuery = require('jquery');
import { Modal } from 'bootstrap/dist/js/bootstrap.min';
import validate from "jquery-validation";